import React, { useEffect, useCallback } from 'react'
import get from 'lodash/get'
import { BTitle, BText, BLink } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import messages from '../../i18n'
import { Notification } from '../../components'
import { NotificationSeverityEnum } from '../../redux/reducers/notification/model'
import { intl, IntlInterface, wizard } from '../../hoc'
import styles from './styles.scss'
import banknote from '../../assets/banknote.svg'
import { appActions } from '../../redux/reducers'
import { ReduxState } from '../../types'
import { NOT_AVAILABLE } from '../../constants'
import { copyToClipboard } from '../../utils/mix'
import { reloadPage } from '../../utils/url'

interface Props extends IntlInterface {
  getSaveReturnUrl: Function
  saveReturnUrl: string
}

const ExitScreen = ({ getSaveReturnUrl, saveReturnUrl, translate }: Props) => {
  useEffect(() => {
    getSaveReturnUrl()
  }, [getSaveReturnUrl])

  const handleReturnUrl = useCallback(() => copyToClipboard(saveReturnUrl), [saveReturnUrl])

  const beforeScoring = saveReturnUrl === NOT_AVAILABLE

  const msg = beforeScoring ? messages.ExitScreen.regular : messages.ExitScreen.afterScoring

  return (
    <div>
      <Notification
        severity={NotificationSeverityEnum.Normal}
        type="success"
        description={translate(msg.logoutMsg)}
      />
      <img src={banknote} alt="" className={styles.cover} />
      <BTitle type="h3" center theme={styles.title}>
        {translate(msg.title)}
      </BTitle>
      <BText type="primary" center theme={styles.subtitle}>
        {translate(msg.subtitle)}
      </BText>
      {beforeScoring ? (
        <BLink onClick={reloadPage}>
          <BText type="info" center>
            {translate(msg.link)}
          </BText>
        </BLink>
      ) : (
        <>
          <BText type="info" center theme={styles.link} id="saveReturnUrlId">
            {saveReturnUrl}
          </BText>
          <BLink onClick={handleReturnUrl}>
            <BText type="info" center>
              {translate(msg.link)}
            </BText>
          </BLink>
        </>
      )}
    </div>
  )
}

export default compose(
  connect(
    (state: ReduxState) => ({
      saveReturnUrl: get(state, 'app.saveReturnUrl'),
    }),
    {
      getSaveReturnUrl: appActions.getSaveReturnUrl,
    }
  ),
  wizard,
  intl
)(ExitScreen)
